import { useQuery } from "@tanstack/react-query";

import { Datasets } from "../../../api/datasets";
import { QueryKey } from "../../../consts/query-keys";
import { CafsTreeData } from "../../../types/cafs-tree-node-type";
import { mapApiToCafsTree } from "../../dashboard-view/utils/map-api-to-tree-node";

export const useCafsList = (datasetId?: number) => {
  const { data: cafsTree, isPending } = useQuery<CafsTreeData>({
    queryKey: [QueryKey.DataSetDetails, datasetId],
    queryFn: () =>
      Datasets.details({
        path: { datasetId: datasetId! },
      }).then(data => {
        return mapApiToCafsTree(data) as CafsTreeData;
      }),
    enabled: !!datasetId,
  });

  const trees =
    cafsTree?.items.find(item => item.type === "Tree")?.childNodes || [];

  const crops =
    cafsTree?.items.find(item => item.type === "Crop")?.childNodes || [];

  const inputs =
    cafsTree?.items.find(item => item.type === "Input")?.childNodes || [];

  return { trees, crops, inputs, isPending };
};
